export const EXPANDED_WIDTH = 324;
export const COLLAPSED_WIDTH = 0;
